/**
 * MitEvida API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ValidateEmailResponse = 'SUCCESS' | 'INVALID_CODE' | 'FAILED';

export const ValidateEmailResponse = {
    SUCCESS: 'SUCCESS' as ValidateEmailResponse,
    INVALIDCODE: 'INVALID_CODE' as ValidateEmailResponse,
    FAILED: 'FAILED' as ValidateEmailResponse
};

